import React from "react";
import AppFooterWeb from "../../components/AppFooterWeb";

export class Collections extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleClick = (name) => {
    this.props.history.push(name);
  };

  render() {
    return (
      <>
        <div className="banner-section">
          <div className="collections-page">
            <div className="collections-blank"></div>
            <div className="collection-text">
              <p>Collections</p>
            </div>
            <div className="collections-container">
              <div className="collection-container">
                <img
                  src={require("../../assets/images/stories-desktop.png")}
                  className="collection-images"
                  alt="stories"
                  onClick={() => this.handleClick("stories")}
                />
                <img
                  src={require("../../assets/images/stories.png")}
                  className="collection-img-mobile"
                  alt="stories"
                  onClick={() => this.handleClick("stories")}
                />
                <img
                  src={require("../../assets/images/amps-desktop.png")}
                  className="collection-images"
                  alt="amps"
                  onClick={() => this.handleClick("amps")}
                />
                <img
                  src={require("../../assets/images/Artists.png")}
                  className="collection-img-mobile"
                  alt="Artists"
                  onClick={() => this.handleClick("artist-list")}
                />
              </div>
              <div className="collection-container">
                <img
                  src={require("../../assets/images/Artists-desktop.png")}
                  className="collection-images"
                  alt="Artists"
                  onClick={() => this.handleClick("artist-list")}
                />
                <img
                  src={require("../../assets/images/Posters.png")}
                  className="collection-img-mobile"
                  alt="Posters"
                  onClick={() => this.handleClick("posters")}
                />
                <img
                  src={require("../../assets/images/photos-desktop.png")}
                  className="collection-images"
                  alt="photos"
                  onClick={() => this.handleClick("photos")}
                />
                <img
                  src={require("../../assets/images/instruments.png")}
                  className="collection-img-mobile"
                  alt="instruments"
                  onClick={() => this.handleClick("instruments")}
                />
              </div>
              <div className="collection-container">
                <img
                  src={require("../../assets/images/Posters-desktop.png")}
                  className="collection-images"
                  alt="Posters"
                  onClick={() => this.handleClick("posters")}
                />
                <img
                  src={require("../../assets/images/amps.png")}
                  className="collection-img-mobile"
                  alt="amps"
                  onClick={() => this.handleClick("amps")}
                />
                <img
                  src={require("../../assets/images/tshirts-desktop.png")}
                  className="collection-images"
                  alt="tshirts"
                  onClick={() => this.handleClick("tshirts")}
                />
                <img
                  src={require("../../assets/images/photos.png")}
                  className="collection-img-mobile"
                  alt="photos"
                  onClick={() => this.handleClick("photos")}
                />
              </div>
              <div className="collection-container">
                <img
                  src={require("../../assets/images/instruments-desktop.png")}
                  className="collection-images"
                  alt="instruments"
                  onClick={() => this.handleClick("instruments")}
                />
                <img
                  src={require("../../assets/images/tshirts.png")}
                  className="collection-img-mobile"
                  alt="tshirts"
                  onClick={() => this.handleClick("tshirts")}
                />
                <img
                  src={require("../../assets/images/liveaid-desktop.png")}
                  className="collection-images"
                  alt="liveaid"
                  onClick={() => this.handleClick("liveaid")}
                />
                <img
                  src={require("../../assets/images/live aid.png")}
                  className="collection-img-mobile"
                  alt="liveaid"
                  onClick={() => this.handleClick("liveaid")}
                />
              </div>
            </div>
          </div>
        </div>
        <AppFooterWeb
          pathName={this.props.location?.pathname}
          history={this.props.history}
        />
      </>
    );
  }
}

export default Collections;
